import { render, staticRenderFns } from "./LocalLinks.vue?vue&type=template&id=2e88e4d7&scoped=true&"
import script from "./LocalLinks.vue?vue&type=script&lang=js&"
export * from "./LocalLinks.vue?vue&type=script&lang=js&"
import style0 from "./LocalLinks.vue?vue&type=style&index=0&id=2e88e4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88e4d7",
  null
  
)

export default component.exports